export const DisplayMode = {
  YIELD: 'yield',
  PRICE: 'price',
}

export type DisplayModeType = (typeof DisplayMode)[keyof typeof DisplayMode]

export const TimeRange = {
  ONE_DAY: '1D',
  ONE_WEEK: '1W',
  ONE_MONTH: '1M',
  THREE_MONTHS: '3M',
  SIX_MONTHS: '6M',
  ONE_YEAR: '1Y',
  ALL: 'All',
}

export type TimeRangeType = (typeof TimeRange)[keyof typeof TimeRange]
